// extracted by mini-css-extract-plugin
export default {"label":"SelectUploadImageDialog_label__ZPRkF"};